<template>
  <div id="app">
    <div v-if="cmsState.preview" class="cms-preview-indicator">草稿预览 · 尚未发布</div>
    <page-header></page-header>
    <div class="container">
      <router-view v-if="cmsState.status < 400" :key="$route.path + ':' + cmsState.version" />
      <section v-else class="cms-runtime-error"><h1>{{ cmsState.status === 404 ? '页面不存在或已下线' : cmsState.status === 403 ? '预览已过期，请从后台重新打开' : '内容暂时不可用，请稍后重试' }}</h1></section>
      <cms-extra-blocks v-if="cmsState.status < 400 && cmsState.page" :blocks="cmsState.page.blocks" />
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import CmsExtraBlocks from './cms/CmsExtraBlocks.vue'
import PageHeader from '@/layout/Header.vue'
import PageFooter from '@/layout/Footer.vue'
import { loadTrackJs, isClient } from '@/utils'

export default {
  computed: { cmsState() { return this.$store.state.cms } },
  components: {
    CmsExtraBlocks,
    PageHeader,
    PageFooter
  },

  mounted() {
    isClient(() => {
      loadTrackJs()
    })
  },

  destroyed() {
    window.lib.storage.rm('nextUrl')
  }
}
</script>

<style lang="less">
html {
  min-width: 1420px;
  overflow-x: auto;
  background-color: #F0F2F5;
}
.container {
  min-height: calc(100vh - 580px);
  overflow-x: hidden;
}

@media screen and (max-width: 1440px) {
  .container {
    min-height: calc(100vh - 460px);
  }
}
</style>

<style>
.cms-runtime-error{padding:160px 30px;text-align:center;background:#fff}.cms-preview-indicator{position:fixed;z-index:99999;bottom:16px;left:16px;border-radius:6px;padding:9px 16px;background:#e86d31;color:white;font-size:14px;box-shadow:0 3px 12px #0002}
</style>
